import { createAction, props } from '@ngrx/store';
import {UUID} from '../../../shared/types/uuid.type';

const prefix = '[DeleteManyStreamConfigurations] ';

export const deleteManyStreamConfigurations = createAction(
  `${prefix} Delete Many Stream Configurations`,
  props<{ ids: UUID[] }>()
);

export const deleteManyStreamConfigurationsSuccess = createAction(
  `${prefix} Delete Many Stream Configurations Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyStreamConfigurationsFailure = createAction(
  `${prefix} Delete Many Stream Configurations Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyStreamConfigurationsState = createAction(
  `${prefix} Clear Delete Many Stream Configurations State`,
);
